module.exports = __webpack_public_path__ + "img/ico_badge10.1806e17b.svg";